module.exports = __webpack_public_path__ + "static/825154854.1c3568bb.jpg";